<template>
  <transition-group
    appear
    class="row back"
    :css="false"
    v-on:before-appear="beforeAppear"
    v-on:appear="appear"
  >
    <div
      v-for="(n, index) in 9"
      :key="n"
      :data-index="index"
      :class="colClass(n)"
    ></div>
  </transition-group>
  <!-- <div class="row back">
    <div class="col-xs col-sm col-md-1 bord"></div>
    <div class="col-xs col-sm col-md-1 bord"></div>
    <div class="col-xs col-sm col-md-1 bord"></div>
    <div class="col-xs col-sm col-md-1 bord"></div>
    <div class="col-xs col-sm col-md-1 bord"></div>
    <div class="col-xs col-sm col-md-1 bord"></div>
    <div class="col-xs col-sm col-md-1 bord"></div>
    <div class="col-xs col-md-1 bord"></div>
    <div class="col-xs col-md-1 bord"></div>
  </div> -->
</template>

<script>
export default {
  name: "GridCol",
  methods: {
    colClass: function(num) {
      let classStr = " bord";
      num = 9 - num;
      if (num > 5) {
        classStr = "col-xs" + classStr;
      } else if (num > 1) {
        classStr = "col-sm" + classStr;
      } else {
        classStr = "col-md" + classStr;
      }
      return classStr;
    },
    beforeAppear: function(el) {
      el.style.transform = "translateY(-100vh)";
    },
    appear: function(el, done) {
      let delay = el.dataset.index * 300;
      el.addEventListener("transitionend", done, { once: true });
      setTimeout(function() {
        el.style.transform = "translateY(0)";
      }, delay);
    }
  }
};
</script>

<style lang="scss" scoped>
// *{
//   border: 1px solid red!important;
// }
.back {
  height: 100vh;
  // border: 1px solid red !important;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  :first-child {
    background-image: $dottedLine, $dottedLine;
    background-position: right, left;
    background-size: 1px 6px;
    background-repeat: repeat-y;
  }
}
.bord {
  // border: 1px solid red;
  background-image: $dottedLine;
  background-position: right;
  background-size: 1px 6px;
  background-repeat: repeat-y;
  transform-origin: center top;
  transition: transform 1.25s 400ms;
}
</style>
